import { Link } from 'react-router-dom'

const logo = require('../assets/img/logo1.png')

export default function Logo() {
      return (
        <Link to={'/'} className='logo'>
          <img 
            src={logo} 
            alt="Logo" 
            style={{ width: '120px'}} 
          />
          
        </Link>
      );
    }
